import styled from "styled-components";
import {brand} from "theme/tokens";

/**
 * Externalized styles for {@link ./TileRemoveButton}.
 *
 * Overlaid on the picture rather than placed in the control row beneath it (ui#760), which is why this
 * is absolutely positioned: its offset parent is the `ImageTile` in `./PageThemeSection.styles`, whose
 * first child is the image, so `top/right` lands on the image's top-right corner on both surfaces
 * without either of them positioning anything itself.
 *
 * Red is `brand.error` over `brand.white`, the same mode-independent destructive pair as
 * `components/confirm/ConfirmDialog.styles`'s `DangerButton` — never a per-mode palette red, because a
 * control that sits ON the sender's own photograph has no theme surface behind it to be read against.
 */
export const Root = styled.button.attrs({type: "button"})`
	position: absolute;
	top: 4px;
	right: 4px;
	/*
	 * Matched to the tile's other controls (TileButton is 30x26) rather than shrunk to look neat: this
	 * REPLACES one of those buttons, and a corner overlay is already the harder target of the two. The
	 * whole row sits below the 44px WCAG 2.5.8 asks for, which a 108px-wide tile cannot give a control
	 * without covering the picture it acts on — but that is the row's standing constraint, and this
	 * control should not make it worse on its own.
	 */
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	box-sizing: border-box;
	border-radius: 50%;
	/*
	 * The ring is the card surface, not a hairline: it separates the disc from whatever the sender
	 * uploaded underneath, which may be any colour at all — including this exact red.
	 */
	border: 1.5px solid ${({theme}) => theme.tokens.card};
	background-color: ${brand.error};
	color: ${brand.white};
	font-size: 13px;
	line-height: 1;
	cursor: pointer;
	transition: 0.14s;

	&:hover:not(:disabled) {
		filter: brightness(0.94);
	}

	&:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	&:focus-visible {
		outline: 2px solid ${brand.error};
		outline-offset: 2px;
	}
`;
